import { createI18n } from "vue-i18n";

// Dynamically load locale messages
const loadLocaleMessages = async (locale) => {
  switch (locale) {
    case "es":
      return (await import("@/locales/es.js")).default;
    case "en":
    default:
      return (await import("@/locales/en.js")).default;
  }
};

// Helper to get the default locale (from localStorage or browser)
const getDefaultLocale = () => {
  const saved = localStorage.getItem("user-locale");
  const browser = navigator.language?.split("-")[0];
  const supported = ["en", "es"];
  return saved || (supported.includes(browser) ? browser : "en");
};

// Function to initialize the i18n instance with the appropriate locale
export const createI18nInstance = async () => {
  const locale = getDefaultLocale();
  const messages = await loadLocaleMessages(locale);

  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: "en",
    messages: {
      [locale]: messages,
    },
  });
};
